import { render, staticRenderFns } from "./ModalImage.vue?vue&type=template&id=8a9f1788&scoped=true&"
import script from "./ModalImage.vue?vue&type=script&lang=js&"
export * from "./ModalImage.vue?vue&type=script&lang=js&"
import style0 from "./ModalImage.vue?vue&type=style&index=0&id=8a9f1788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f1788",
  null
  
)

export default component.exports